import React, { useEffect, useState, useContext } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import styles from './SinglePostPage.module.css';
import { PostContext } from '../../../createContext/Post/PostContext';
import Post from '../Post';

const SinglePostPage = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [post, setPost] = useState(null);
  const { getPostById, loading } = useContext(PostContext);

  useEffect(() => {
    const loadPost = async () => {
      try {
        const postData = await getPostById(id);
        setPost(postData);
      } catch (err) {
        console.error('Error loading post:', err);
      }
    };

    loadPost();
  }, [id]);

  const handleBack = () => {
    navigate(-1);
  };

  const handleCommentOpen = (postId) => {
    // Keep your existing comment opening logic
    console.log('Opening comments for post:', postId);
  };

  if (loading) {
    return (
      <div className={styles.container}>
        <div className={styles.loadingSpinner}>
          <div className={styles.spinner}></div>
          <span>Loading post...</span>
        </div>
      </div>
    );
  }

  if (!post && !loading) {
    return (
      <div className={styles.container}>
        <div className={styles.error}>
          <h2>Post Not Found</h2>
          <p>The post you're looking for doesn't exist or has been removed.</p>
          <button onClick={handleBack} className={styles.backButton}>
            ← Go Back
          </button>
        </div>
      </div>
    );
  }

  return (
    <div className={styles.container}>
      <header className={styles.header}>
        <button onClick={handleBack} className={styles.backButton}>
          ← Back
        </button>
        <h1 className={styles.title}>Post</h1>
      </header>
      
      <main className={styles.main}>
        {post && (
          <Post
            {...post}
            openComment={handleCommentOpen}
          />
        )}
      </main>
    </div>
  );
};

export default SinglePostPage;